import { useContext } from 'react';
import AuthContext from 'src/contexts/InfinityAuthContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
